import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { responsive } from "../../utils/style";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  const indent = () => <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
  const navigate = useNavigate();

  const url =
    process.env.REACT_APP_FRONTEND_URL || "https://webapp.sonkthaiglairok.com";

  return (
    <Background>
      <Container>
        <ContentContainer>
          <center>
            <Topic>นโยบายคุกกี้ (Cookie Policy)</Topic>
          </center>
          <SubTopic>นโยบายคุกกี้</SubTopic>
          <Text>
            {indent()}เมื่อท่านได้เข้าสู่เว็บแอปพลิเคชัน เณรกล้า โภชนาดี
            และแบบทดสอบชุดความรู้ เณรกล้า โภชนาดี (เว็บแอปฯ)
            <Link onClick={() => navigate("/")}> ({url}) </Link>
            ข้อมูลที่เกี่ยวข้องกับการเข้าสู่เว็บแอปฯ
            ของท่านจะถูกบันทึกไว้ในรูปแบบของคุกกี้
            โดยนโยบายคุกกี้นี้จะอธิบายถึงความหมาย การทำงาน วัตถุประสงค์
            รวมถึงการลบและการปฏิเสธการเก็บคุกกี้ เพื่อความเป็นส่วนตัวของท่าน
            โดยการเข้าสู่เว็บแอปฯ
            นี้ถือว่าท่านได้อนุญาตให้เราใช้คุกกี้ตามนโยบายคุกกี้ที่มีรายละเอียดดังต่อไปนี้
          </Text>
          <SubTopic>คุกกี้คืออะไร (Cookie)</SubTopic>
          <Text>
            {indent()}คุกกี้ คือ ไฟล์เล็ก ๆ
            เพื่อจัดเก็บข้อมูลการเข้าใช้งานเว็บไซต์หรือเว็บแอปพลิเคชัน เช่น
            ข้อมูลการเข้าสู่ระบบ วันเวลา ลิงค์ที่คลิก หน้าที่เข้าชม
            เงื่อนไขการตั้งค่าต่าง ๆ โดยจะบันทึกลงไปในอุปกรณ์คอมพิวเตอร์
            และ/หรือ เครื่องมือสื่อสารที่เข้าใช้งานของท่าน เช่น โน้ตบุ๊ค
            แท็บเล็ต หรือ สมาร์ทโฟน
            ผ่านทางเว็บเบราว์เซอร์ในขณะที่ท่านเข้าสู่เว็บไซต์
            โดยคุกกี้จะไม่ก่อให้เกิดอันตรายต่ออุปกรณ์คอมพิวเตอร์ และ/หรือ
            เครื่องมือสื่อสารของท่าน ในกรณีดังต่อไปนี้
            ข้อมูลส่วนบุคคลของท่านอาจถูกจัดเก็บเพื่อใช้เพิ่มประสบการณ์การใช้งานบริการทางออนไลน์
            โดยจะจำเอกลักษณ์ของภาษาและปรับแต่งข้อมูลการใช้งานตามความต้องการของท่าน
            เป็นการยืนยันคุณลักษณะเฉพาะตัว ข้อมูลความปลอดภัยของท่าน
            รวมถึงบริการที่ท่านสนใจ
            นอกจากนี้คุกกี้ยังถูกใช้เพื่อวัดปริมาณการเข้าใช้งานบริการทางออนไลน์
            การปรับเปลี่ยนเนื้อหาตามการใช้งานของท่านโดยพิจารณาจากพฤติกรรมการเข้าใช้งานครั้งก่อน
            ๆ และ ณ ปัจจุบันและอาจมีวัตถุประสงค์เพื่อการโฆษณาประชาสัมพันธ์
            ทั้งนี้ท่านสามารถค้นหาข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้ได้ที่
            www.allaboutcookies.org
          </Text>
          <SubTopic>เว็บแอปฯ ใช้คุกกี้อย่างไร</SubTopic>
          <Text>
            {indent()}เว็ปแอปฯ ใช้คุกกี้ เพื่อบันทึกข้อมูลการเข้าสู่ระบบ
            ผ่านการลงทะเบียนของเว็บแอปฯ เช่น ชื่อ ชื่อเล่น ห้องเรียน ชั้นเรียน
            โทเค็น โดยทำให้เว็ปแอปฯ สามารถแสดงผลได้อย่างถูกต้อง
            และสามารถให้ท่านเข้าถึงฟังก์ชันการทำงาน เช่น โปรไฟล์
            กรอกข้อมูลปริมาณการรับประทานผัก เครื่องดื่ม และการออกกกำลังกาย
            ในสัปดาห์ หรือตลอดภาคการศึกษา กรอกข้อมูลภาวะโภชนาการ
            ดูรายงานการกรอกข้อมูลปริมาณการรับประทานผัก เครื่องดื่ม
            การออกกำลังกายหรือภาวะโภชนาการ
            และการให้คะแนนหรือจัดลำดับการรับประทานผัก เครื่องดื่ม
            และการออกกำลังกาย รวมทั้ง คะแนนจากการทำแบบทดสอบชุดความรู้ เณรกล้า
            โภชนาดี เป็นต้น ทั้งนี้การใช้คุกกี้เป็นไปตาม
            <Link onClick={() => navigate("/privacyNotice")}>
              คำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)
            </Link>
          </Text>
          <Text>
            {indent()}คุกกี้ที่ เว็บแอปฯ ใช้มีดังนี้ <br />
            {indent()}1. <BoldText>Persistent Cookie </BoldText>
            เป็นคุกกี้ที่จะอยู่ตามระยะเวลาที่กำหนดหรือจนกว่าท่านจะลบออก
            คุกกี้ประเภทนี้จะช่วยให้
            ท่านสามารถเข้าถึงฟังก์ชันที่ต้องการให้ท่านเข้าสู่ระบบหรือยืนยันตัวตนโดยแยกตาม
            ข้อมูลบทบาท (Role) ที่ได้จากการเข้าสู่ระบบของท่าน ดังนี้
            <br />
            {indent()}
            {indent()}1.1 <BoldText>สามเณร</BoldText> โปรไฟล์
            กรอกข้อมูลปริมาณการรับประทานผัก เครื่องดื่ม การออกกำลังกาย
            กรอกข้อมูลภาวะโภชนาการ คะแนนจากการทำแบบทดสอบชุดความรู้ เณรกล้า
            โภชนาดี ขอทราบผลการกรอกข้อมูลรายวัน / รายสัปดาห์ / ทั้งหมด
            (สรุปเป็นภาคการศึกษา) ขอทราบผลการจัดอันดับ รางวัลที่ได้รับ เป็นต้น
            <br />
            {indent()}
            {indent()}1.2 <BoldText>ครู </BoldText>โปรไฟล์
            ดูข้อมูลการกรอกการรับประทานอาหารสามเณรที่รับผิดชอบ
            ดูข้อมูลการกรอกข้อมูลภาวะโภชนาการของสามเณรที่รับผิดชอบ
            และดูคะแนนจากการทำแบบทดสอบชุดความรู้ เณรกล้า โภชนาดี
            โดยดูเป็นแบบชั้นเรียน ห้องเรียน ข้อมูลการจัดอันดับของสามเณร
            รางวัลที่สามเณรได้รับ เป็นต้น
          </Text>
          <Text>
            {indent()}วัตถุประสงค์ในการใช้งานคุกกี้ที่ เว็บแอปฯ ใช้
            มีรายละเอียดดังนี้
            <br />
            {indent()}
            {indent()}
            <BoldText>
              1. คุกกี้ที่มีความจำเป็น (Strictly Necessary Cookies)
            </BoldText>{" "}
            คุกกี้ประเภทนี้มีความจำเป็นต่อการให้บริการเว็บไซต์ของ
            คุกกี้ประเภทนี้มีความจำเป็นต่อการให้บริการเว็บไซต์ของ เว็บแอปฯ
            เพื่อให้ท่านสามารถเข้าใช้งานในส่วนโปรไฟล์
            กรอกข้อมูลปริมาณการรับประทานผัก เครื่องดื่ม และการออกกำลังกาย
            ในสัปดาห์ หรือตลอดภาคการศึกษา กรอกข้อมูลภาวะโภชนาการ
            ดูรายงานการกรอกข้อมูลปริมาณการรับประทานผัก เครื่องดื่ม
            และการออกกำลังกายหรือภาวะโภชนาการ
            และการให้คะแนนหรือจัดลำดับปริมาณการรับประทานผัก เครื่องดื่ม
            และการออกกำลังกาย เป็นต้น
            การปิดการใช้งานคุกกี้ประเภทนี้จะส่งผลให้ท่านไม่สามารถใช้บริการดังกล่าวของ
            เว็บแอปฯ ได้
            <br /> {indent()}
            {indent()}First Name (ชื่อ)
            <br /> {indent()}
            {indent()}Nickname (ชื่อเล่น)
            <br /> {indent()}
            {indent()}Role (บทบาท)
            <br /> {indent()}
            {indent()}Class (ชั้นเรียน)
            <br /> {indent()}
            {indent()}RoomNo (ห้องเรียน)
            <br /> {indent()}
            {indent()}Token (โทเค็น)
            <br />
            {indent()}RefreshToken (รีเฟรชโทเค็น)
            <br />
            <BoldText>
              กรณีผู้ที่ลงทะเบียนประสงค์ทำเฉพาะแบบทดสอบชุดความรู้ เณรกล้า
              โภชนาดีเพียงอย่างเดียว
            </BoldText>
            <br />
            ในการลงทะเบียนแยกเฉพาะแบบทดสอบชุดความรู้ เณรกล้า โภชนาดี ใช้คุกกี้
            เพื่อบันทึกข้อมูลการเข้าสู่ระบบ เช่น ชื่อสมมุติ โทเค็น โดยทำให้
            แบบทดสอบชุดความรู้ เณรกล้า โภชนาดี สามารถแสดงผลได้อย่างถูกต้อง
            และสามารถให้ท่านเข้าถึงฟังก์ชันการทำงาน เช่น โปรไฟล์
            คะแนนจากการทำแบบทดสอบชุดความรู้ เณรกล้า โภชนาดี เป็นต้น
            ทั้งนี้การใช้คุกกี้เป็นไปตาม
            <Link onClick={() => navigate("/privacyNotice")}>
              คำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)
            </Link>
            <br />
            <br />
            <BoldText>
              2. คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ
              (Analytical/Performance Cookies):
            </BoldText>{" "}
            คุกกี้ประเภทนี้จะช่วยให้เราสามารถจดจำและนับจำนวนผู้เข้าเยี่ยมชมเว็บไซต์ตลอดจนช่วยให้เราทราบถึงพฤติกรรมในการเยี่ยมชมเว็บไซต์
            เพื่อปรับปรุงการทำงานของเว็บไซต์ให้มีคุณภาพดีขึ้นและมีความเหมาะสมมากขึ้น
            อีกทั้งเพื่อรวบรวมข้อมูลทางสถิติเกี่ยวกับวิธีการเข้าและพฤติกรรมการเยี่ยมชมเว็บไซต์
            ซึ่งจะช่วยปรับปรุงการทำงานของเว็บไซต์โดยให้ผู้ใช้งานสามารถค้นหาสิ่งที่ต้องการได้อย่างง่ายดาย
            และช่วยให้เราเข้าใจถึงความสนใจของผู้ใช้
            และวัดความมีประสิทธิผลของเว็บไซต์ของเรา ซึ่งในเว็บแอปฯ
            จะมีคุกกี้ที่เกิดจากใช้งาน Google Analytics
            ช่วยให้เราสามารถจดจำและนับจำนวนผู้เข้าเยี่ยมชมเว็บไซต์ตลอดจนช่วยให้
            ทราบถึงพฤติกรรมในการเยี่ยมชมเว็บไซต์
            <br /> {indent()}
            {indent()}__gid
            <br /> {indent()}
            {indent()}__ga
            <br />
          </Text>
          <SubTopic>ท่านจะจัดการคุกกี้ได้อย่างไร</SubTopic>
          <Text>
            {indent()}
            เบราวเซอร์ส่วนใหญ่จะมีการตั้งค่าให้มีการยอมรับคุกกี้เป็นค่าเริ่มต้น
            อย่างไรก็ตาม
            ท่านสามารถปฏิเสธการใช้งานหรือลบคุกกี้ในหน้าการตั้งค่าของเบราวเซอร์ที่ท่านใช้งานอยู่
            ทั้งนี้
            หากท่านทำการปรับเปลี่ยนการตั้งค่าเบราวเซอร์ของท่านอาจส่งผลกระทบต่อรูปแบบและการใช้งานบนหน้าเว็บแอปพิลเคชันของเราได้
            อาจจะทำให้ท่านไม่สามารถใช้งานเว็บแอปพลิเคชันต่อได้หรือการแสดงผลของเว็บแอปพลิเคชันอาจจะเกิดข้อผิดพลาด
            หากท่านประสงค์ที่จะทำการปรับเปลี่ยนการตั้งค่า
            ท่านสามารถตรวจสอบรายละเอียดเพิ่มเติมได้ตามลิงก์ที่ได้ระบุไว้ข้างล่าง
            <br />
            {indent()}
            <ALink href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en&oco=1">
              Android (Chrome)
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac">
              Apple (Safari)
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DiOS&hl=en&oco=1">
              Iphone or Ipad (Chrome)
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.apple.com/en-us/HT201265">
              Iphone or Ipad (Safari)
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en">
              Google Chrome
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd">
              Microsoft Edge
            </ALink>
            <br /> {indent()}
            <ALink href="https://docs.blackberry.com/content/dam/docs-blackberry-com/release-pdfs/en/device-user-guides/BlackBerry-Classic-Smartphone-10.3.3-User-Guide-en.pdf">
              Blackberry
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d">
              Microsoft Internet Explorer
            </ALink>
            <br />
            {indent()}
            <ALink href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&redirectlocale=en-US">
              Mozilla Firefox
            </ALink>
            <br />
            {indent()}
            <ALink href="https://help.opera.com/en/latest/web-preferences/">
              Opera
            </ALink>
            <br />
            {indent()}ทั้งนี้ โปรดทราบว่า
            หากท่านเลือกที่จะปิดการใช้งานคุกกี้บนเบราว์เซอร์หรืออุปกรณ์ของท่าน
            อาจส่งผลกระทบกับการทำงานบางส่วนของ เว็บแอปฯ
            ทำให้ไม่สามารถทำงานหรือให้บริการได้เป็นปกติ <br />
            {indent()}เว็บแอปฯ จะไม่รับผิดชอบและ เว็บแอปฯ
            ไม่ได้มีความเกี่ยวข้องกับเว็บไซต์ รวมทั้งเนื้อหาในเว็บไซต์ต่าง ๆ
            ที่กล่าวมาข้างต้น <br />
            {indent()}สำหรับข้อมูลอื่น ๆ เพิ่มเติมในเรื่องนี้
            ท่านสามารถเข้าไปอ่านได้ที่{" "}
            <ALink href="https://www.aboutcookies.org/how-to-delete-cookies">
              https://www.aboutcookies.org/how-to-delete-cookies
            </ALink>
          </Text>
          <SubTopic>การเชื่อมโยงข้อมูลกับเว็บไซต์อื่น</SubTopic>
          <Text>
            {indent()}เว็บแอปฯ
            อาจมีการเชื่อมโยงไปยังเว็บไซต์หรือโซเชียลมีเดียของบุคคลภายนอก
            รวมถึงอาจมีการฝังเนื้อหาหรือวิดีโอที่มาจากโซเชียลมีเดีย เช่น YouTube
            หรือ Facebook เป็นต้น
            ซึ่งจะช่วยให้ท่านเข้าถึงเนื้อหาและสร้างการปฏิสัมพันธ์กับบุคคลอื่นบนโซเชียลมีเดียจากเว็บแอปฯ
            ได้ หรือการใช้บริการ Google Analytics ของเว็บแอปฯ
            ซึ่งจะช่วยให้สามารถจดจำและนับจำนวนผู้เข้าเยี่ยมชมเว็บไซต์ตลอดจนช่วยให้
            ทราบถึงพฤติกรรมในการเยี่ยมชมเว็บไซต์เพื่อปรับปรุงประสิทธิภาพให้ดีขึ้น
            ซึ่งเว็บไซต์หรือโซเชียลมีเดียของบุคคลภายนอกจะมีการกำหนดและตั้งค่าคุกกี้ขึ้นมาเอง
            โดยที่ เว็บแอปฯ ไม่สามารถควบคุมหรือรับผิดชอบต่อคุกกี้เหล่านั้นได้
            และขอแนะนำให้ท่านควรเข้าไปอ่านและศึกษานโยบายหรือประกาศการใช้คุกกี้ของบุคคลภายนอกเหล่านั้นด้วย
          </Text>
          <SubTopic>การเปลี่ยนแปลงประกาศ</SubTopic>
          <Text>
            {indent()}
            ประกาศนี้อาจมีการปรับปรุงให้เหมาะสมและสอดคล้องกับสถานการณ์และตามการให้บริการจริง
            โดย เว็บแอปฯ จะมีการแจ้งประกาศที่มีการปรับปรุงใหม่บนเว็บไซต์นี้
            ดังนั้น เว็บแอปฯ
            ขอแนะนำให้ท่านตรวจสอบให้แน่ใจว่าท่านได้เข้าใจการเปลี่ยนแปลงตามข้อกำหนดดังกล่าว
          </Text>
          <SubTopic>ติดต่อ</SubTopic>
          <Text>
            {indent()}ในกรณีที่ท่านมีคำถามเกี่ยวกับนโยบายคุกกี้ของเรา
            ท่านสามารถติดต่อสอบถามได้ที่ <br />
            {indent()}
            <BoldText>
              เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer: DPO)
            </BoldText>
            <br />
            {indent()}ชื่อ: <BoldText>นายสุรวิชญ์ ศรีคาร</BoldText>
            <br />
            {indent()}สถานที่ติดต่อ: กองกิจการนิสิต สำนักงานอธิการบดี
            มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย อาคาร เรียนรวมโซน A ชั้น A300
            ชั้น 3 เลขที่ 79 ถนนพหลโยธิน ตำบลลำไทร อำเภอวังน้อย
            จังหวัดพระนครศรีอยุธยา รหัสไปรษณีย์ 13170
            <br />
            {indent()}ช่องทางการติดต่อ: <br />
            {indent()}
            {indent()}โทรศัพท์ <ALink href="tel://035248000">035-248000</ALink>{" "}
            <span>ต่อ 8401 8402 8405 8406 8408</span>
            <br />
            {indent()}
            {indent()}อีเมล{" "}
            <ALink href="mailto: markvocal2@gmail.com">
              markvocal2@gmail.com
            </ALink>
          </Text>
          <center>
            <Text>ประกาศ ณ วันที่ 16 มกราคม 2566</Text>
          </center>
        </ContentContainer>
      </Container>
    </Background>
  );
};

export default CookiePolicy;

const BoldText = styled.span`
  font-weight: 700;
`;

const Link = styled(BoldText)`
  color: #ff6a40;
  cursor: pointer;
`;

const ALink = styled.a`
  font-weight: 700;
  color: #ff6a40;
  cursor: pointer;
`;

const Topic = styled.h1`
  font-size: 40px;
  color: #ff6a40;
`;

const Text = styled.p`
  font-size: 16px;
`;

const SubTopic = styled.h2`
  color: #047751;
`;

const Background = styled.div`
  background: #fffbeb;
  font-family: "Noto Sans Thai", "Noto Sans";
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 1144px;
  background: #ffffff;
`;

const ContentContainer = styled.div`
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;

  ${responsive.tablet(css`
    // margin-top: 24px;
    // max-width: 834px;
    // margin: auto;
    // margin-bottom: 24px;
    margin: 24px 24px 24px 24px;
  `)}

  ${responsive.mobile(css`
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 24px;
  `)}
`;
